export enum BadgeColorEnum {
  RED = 'RED',
  PINK = 'PINK',
  PURPLE = 'PURPLE',
  INDIGO = 'INDIGO',
  BLUE = 'BLUE',
  LIGHT_BLUE = 'LIGHT_BLUE',
  CYAN = 'CYAN',
  TEAL = 'TEAL',
  GREEN = 'GREEN',
  LIME = 'LIME',
  YELLOW = 'YELLOW',
  ORANGE = 'ORANGE',
  GRAY = 'GRAY',
  BLACK = 'BLACK',
  WHITE = 'WHITE',
}

export const BADGE_COLOR_VALUES: BadgeColorEnum[] = [
  BadgeColorEnum.RED,
  BadgeColorEnum.PINK,
  BadgeColorEnum.PURPLE,
  BadgeColorEnum.INDIGO,
  BadgeColorEnum.BLUE,
  BadgeColorEnum.LIGHT_BLUE,
  BadgeColorEnum.CYAN,
  BadgeColorEnum.TEAL,
  BadgeColorEnum.GREEN,
  BadgeColorEnum.LIME,
  BadgeColorEnum.YELLOW,
  BadgeColorEnum.ORANGE,
  BadgeColorEnum.GRAY,
  BadgeColorEnum.BLACK,
  BadgeColorEnum.WHITE,
];

export const BADGE_COLOR_HEX_MAP: Record<BadgeColorEnum, string> = {
  [BadgeColorEnum.RED]: '#FA5252',
  [BadgeColorEnum.PINK]: '#E64980',
  [BadgeColorEnum.PURPLE]: '#BE4BDB',
  [BadgeColorEnum.INDIGO]: '#7950F2',
  [BadgeColorEnum.BLUE]: '#4C6EF5',
  [BadgeColorEnum.LIGHT_BLUE]: '#228BE6',
  [BadgeColorEnum.CYAN]: '#15AABF',
  [BadgeColorEnum.TEAL]: '#12B886',
  [BadgeColorEnum.GREEN]: '#40C057',
  [BadgeColorEnum.LIME]: '#82C91E',
  [BadgeColorEnum.YELLOW]: '#FAB005',
  [BadgeColorEnum.ORANGE]: '#FD7E14',
  [BadgeColorEnum.GRAY]: '#868E96',
  [BadgeColorEnum.BLACK]: '#212529',
  [BadgeColorEnum.WHITE]: '#FFFFFF',
};

export const BADGE_COLOR_PASTEL_MAP: Record<BadgeColorEnum, string> = {
  [BadgeColorEnum.RED]: '#FFE3E3',
  [BadgeColorEnum.PINK]: '#FFDEEB',
  [BadgeColorEnum.PURPLE]: '#F3D9FA',
  [BadgeColorEnum.INDIGO]: '#E5DBFF',
  [BadgeColorEnum.BLUE]: '#DBE4FF',
  [BadgeColorEnum.LIGHT_BLUE]: '#D0EBFF',
  [BadgeColorEnum.CYAN]: '#C5F6FA',
  [BadgeColorEnum.TEAL]: '#C3FAE8',
  [BadgeColorEnum.GREEN]: '#D3F9D8',
  [BadgeColorEnum.LIME]: '#E9FAC8',
  [BadgeColorEnum.YELLOW]: '#FFF3BF',
  [BadgeColorEnum.ORANGE]: '#FFE8CC',
  [BadgeColorEnum.GRAY]: '#E9ECEF',
  [BadgeColorEnum.BLACK]: '#DEE2E6',
  [BadgeColorEnum.WHITE]: '#CED4DA',
};

export function getBadgeContrastTextColor(color: BadgeColorEnum): string {
  const lightBackgrounds: BadgeColorEnum[] = [
    BadgeColorEnum.YELLOW,
    BadgeColorEnum.LIME,
    BadgeColorEnum.WHITE,
  ];
  return lightBackgrounds.includes(color) ? '#1f2937' : '#ffffff';
}

export const BADGE_COLOR_SOFT_TEXT_MAP: Record<BadgeColorEnum, string> = {
  [BadgeColorEnum.RED]: '#C92A2A',
  [BadgeColorEnum.PINK]: '#A61E4D',
  [BadgeColorEnum.PURPLE]: '#862E9C',
  [BadgeColorEnum.INDIGO]: '#5F3DC4',
  [BadgeColorEnum.BLUE]: '#364FC7',
  [BadgeColorEnum.LIGHT_BLUE]: '#1864AB',
  [BadgeColorEnum.CYAN]: '#0B7285',
  [BadgeColorEnum.TEAL]: '#087F5B',
  [BadgeColorEnum.GREEN]: '#2B8A3E',
  [BadgeColorEnum.LIME]: '#5C940D',
  [BadgeColorEnum.YELLOW]: '#E67700',
  [BadgeColorEnum.ORANGE]: '#D9480F',
  [BadgeColorEnum.GRAY]: '#495057',
  [BadgeColorEnum.BLACK]: '#212529',
  [BadgeColorEnum.WHITE]: '#495057',
};
